export default __webpack_public_path__ + "static/media/030-rabbit.4861f785.svg";